import { useState } from 'react';

export default function CoverageMap() {
  const [selectedMunicipality, setSelectedMunicipality] = useState('');

  const municipalities = [
    'Barcelona', 'Badalona', 'L\'Hospitalet de Llobregat', 'Santa Coloma de Gramenet',
    'Cornellà de Llobregat', 'Sant Boi de Llobregat', 'Esplugues de Llobregat',
    'Sant Just Desvern', 'Sant Feliu de Llobregat', 'Molins de Rei', 'El Prat de Llobregat',
    'Viladecans', 'Gavà', 'Castelldefels', 'Sant Adrià de Besòs', 'Montgat', 'Tiana',
    'Sant Cugat del Vallès', 'Cerdanyola del Vallès', 'Ripollet', 'Barberà del Vallès'
  ];

  const handleMunicipalityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMunicipality(e.target.value);
  };

  return (
    <section className="py-20 bg-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif font-bold text-4xl md:text-5xl text-primary mb-6">
            Dónde trabajamos
          </h2>
          <p className="text-textLight text-lg max-w-2xl mx-auto">
            Barcelona ciudad y Área Metropolitana. ¿Tu municipio no aparece? Consúltanos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Map Visual */}
          <div className="relative">
            <div className="bg-white rounded-lg p-8 shadow-md">
              <img
                src="https://public.readdy.ai/ai/img_res/beac178807ff14ceb51be3a10c444c9e.jpg"
                alt="Mapa de cobertura Barcelona"
                className="w-full h-auto rounded-lg"
                loading="lazy"
                decoding="async"
              />
              <div className="mt-6 grid grid-cols-2 gap-4">
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-secondary rounded-full"></div>
                  <span className="text-sm text-textLight">Barcelona ciudad</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-accent rounded-full"></div>
                  <span className="text-sm text-textLight">Área Metropolitana</span>
                </div>
              </div>
            </div>
          </div>

          {/* Municipality Selector */}
          <div>
            <h3 className="font-serif font-bold text-2xl text-primary mb-6">
              Selecciona Tu Municipio
            </h3>
            <p className="text-textLight mb-6">
              Cubrimos toda Barcelona y el Área Metropolitana. Selecciona tu municipio para confirmar disponibilidad.
            </p>
            
            <select
              value={selectedMunicipality}
              onChange={handleMunicipalityChange}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:border-secondary transition-colors mb-6 cursor-pointer"
            >
              <option value="">Selecciona tu municipio</option>
              {municipalities.map((municipality, index) => (
                <option key={index} value={municipality}>
                  {municipality}
                </option>
              ))}
            </select>

            {selectedMunicipality && (
              <div className="bg-accent/10 border-l-4 border-accent rounded-lg p-6 mb-6">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-accent text-2xl mt-1"></i>
                  <div>
                    <p className="font-sans font-bold text-primary mb-2">
                      ✓ Cubrimos {selectedMunicipality}
                    </p>
                    <p className="text-textLight text-sm">
                      Trabajamos regularmente en esta zona. Contacta para presupuesto sin compromiso.
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="space-y-4">
              <a
                href="tel:+34690220944"
                className="block w-full bg-primary text-white px-6 py-4 rounded-full font-sans font-semibold text-center hover:bg-opacity-90 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Llamar para Confirmar Cobertura
              </a>
              <a
                href="https://wa.me/34690220944"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-[#25D366] text-white px-6 py-4 rounded-full font-sans font-semibold text-center hover:bg-opacity-90 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Consultar por WhatsApp
              </a>
            </div>

            <p className="text-textLight text-sm mt-6 text-center">
              Si tu municipio no aparece en la lista, contáctanos igualmente. Evaluamos cada caso.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}